
<template>
  <div class="reset__password">
    <Modal v-if="modalActive" :modalMessage="modalMessage" v-on:close-modal="closeModal" />
    <Loading v-if="loading" />
    <div class="form__wrap">
      <form class="reset">
        <p class="login-register">
          العودة الي صفحة
          <router-link class="router-link" :to="{ name: 'Login' }">تسجيل الدخول</router-link>
        </p>
        <h2>اعادة كلمة المرور</h2>
        <p>نسيت كلمة المرور؟ ادخل البريد الالكتروني لأستعادتها</p>
        <div class="inputs">
          <div class="input">
            <input type="text" placeholder="البريد الالكتروني" v-model="email" />
            <email class="icon" />
          </div>
        </div>
        <button @click.prevent="resetPassword">اعادة</button>
        <div class="angle"></div>
      </form>
      <div class="background"></div>
    </div>
  </div>
</template>

<script>
import email from "../assets/Icons/envelope-regular.svg";
import Modal from "../../components/Modal";
import Loading from "../../components/Loading";
import firebase from "firebase/app";
import "firebase/auth";
export default {
  name: "ForgotPassword",
  components: {
    email,
    Modal,
    Loading,
  },
  data() {
    return {
      email: "",
      modalActive: false,
      modalMessage: "",
      loading: null,
    };
  },
  methods: {
    resetPassword() {
      this.loading = true;
      firebase
        .auth()
        .sendPasswordResetEmail(this.email)
        .then(() => {
          this.modalMessage =
            "If your account exists, you will recieve a email";
          this.loading = false;
          this.modalActive = true;
        })
        .catch((err) => {
          this.modalMessage = err.message;
          this.loading = false;
          this.modalActive = true;
        });
    },
    closeModal() {
      this.modalActive = !this.modalActive;
      this.email = "";
    },
  },
};
</script>

<style lang="scss">
.reset__password {
  position: relative;
  .form__wrap {
    .reset {
      h2 {
        margin-bottom: 8px;
      }
      p {
        text-align: center;
        margin-bottom: 32px;
      }
    }
    button{
      padding:6px 17px;
      font-size:16px;
    }
  }
}
</style>
